const UseRefreshSessionAccess = () => {
  var _a, _b, _c;
  if (typeof window === 'undefined') {
    return;
  }
  const oktaToken = localStorage.getItem('okta-token-storage');
  const tokenJson = JSON.parse(oktaToken);
  const customerId = (_a = tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.idToken) === null || _a === void 0 ? void 0 : _a.claims['com.priceline.profile.custId'];
  const custName = (_c = (_b = tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.idToken) === null || _b === void 0 ? void 0 : _b.claims.name) === null || _c === void 0 ? void 0 : _c.replace(/\s/g, '');
  const sessionStatus = localStorage.getItem('sessionStatus');
  if (customerId && custName) {
    localStorage.setItem('psid', `${custName}-${customerId}`);
    localStorage.setItem('sessionStatus', 'true');
  } else if (sessionStatus === 'true') {
    localStorage.removeItem('psid');
    sessionStorage.removeItem('pennysid');
    localStorage.setItem('sessionStatus', 'false');
  }
  return {};
};
export default UseRefreshSessionAccess;